export const partyArray = ["bjp", "congress", "aap", "bsp", "Shivsena", "other"]